<template>
  <section v-if="project" >
    <p v-if="show_text" class="text-center pulseButton">Alle Spenden dieses Vortrags kommen dem {{project.is_association?"":"Projekt"}} <b>"{{project.title}}"</b> zu Gute. {{project.additional}}</p>
    <h2 v-if="!preview" class="text-center font-size-2">{{project.title}}</h2>
    <p v-if="!preview">{{project.teaser}}</p>
    
    
    <RTProjectGallery v-if="!preview" id="project-donation" class="mt-2" :images="project.pics" :preview="true" :cover="project.cover"/>
    
    <!--<p v-if="show_descr" v-html="project.descr"></p>-->
    <p v-if="project.video_url" >
      <iframe style="margin:auto;display:block;" :width="getMaxWidthOfPlayer()" :height="getHeightOfPlayer()"  :src="project.video_url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </p>
    <ul v-if="show_redirect" class="actions special w-100 mt-3">
			<li class="w-100"><router-link class="primary button w-100" :to="'/project/'+project.id">Weiter zum Projekt</router-link></li>
		</ul>
    <RTdonate class="mt-3" :project="project" :stream_id="stream_id" :show_header="true" :show_total_donations="show_total_donations" :limit="limit" :enableStreamNameOption="enableStreamNameOption"/>
  </section>
</template>

<script>
import RTdonate from '@/components/RTdonate.vue'
import RTProjectGallery from '@/components/RTProjectGallery.vue'
import {helper} from '@/mixins/helper.js'
export default {
  name: 'RTProjectDonation',
  mixins:[helper],
  components:{
    RTdonate,
    RTProjectGallery
  },
  props:{
    project:{
      type:Object
    },
    stream_id:{
      type:String
    },
    preview:{
      type:Boolean,
      default:true
    },
    show_text:{
      type:Boolean,
      default:true
    },
    show_descr:{
      type:Boolean,
      default:false
    },
    show_redirect:{
      type:Boolean,
      default:false
    },
    show_total_donations:{
      type:Boolean,
      default:true
    },
    limit:{
      type:Number,
      default:-1
    },
    enableStreamNameOption:{
      type:Boolean,
      default:true
    }
  },
  watch:{
  },
  data: function() {
    return {
    };
  },
  computed:{

  },
  methods:{
       getMaxWidthOfPlayer(){
      //screenWidth() -> einbauen
      return this.isSmallTouchDevice()?300:640;
    },
    getHeightOfPlayer(){
      return this.isSmallTouchDevice()?200:360;
    }
  },

  mounted(){
  },
};
</script>

<style scoped type='text/css'>

</style>